// extracted by mini-css-extract-plugin
export default {"errorIcon":"_2D63K5ovHSKc2QjCQsfoFQ","infoIcon":"_2KYrOeuRsa7mnt_4bL3Azv"};